// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
// NGRX
// Translate
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '../../partials/partials.module';
// Services
import { HttpUtilsService, TypesUtilsService, LayoutUtilsService} from '../../../core/_base/crud';
// Shared
import { ActionNotificationComponent } from '../../partials/content/crud';
import {MatTreeModule} from '@angular/material/tree'

// Components

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatExpansionModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
} from '@angular/material';
import { 
	MachineService,
	ProductService,
	ShiftService,
	QuartelService
} from '../../../core/plant-configuration';
import { RoleGuard } from '../../../core/auth/_guards/role.guard';
import { ModuleListComponent, TreeChecklistExample } from './modules/module-list.component';
import { Controlir4ConfigComponent } from './controlir4-config.component';


const routes: Routes = [
	{
		path: '',
		component: Controlir4ConfigComponent,
		canActivateChild: [RoleGuard],
		children: [
			{
                path: 'modules',
                component: ModuleListComponent,
                data: {
                    groups: [4]
                }
            },
		]
	}
];


@NgModule({
	declarations: [
        Controlir4ConfigComponent,
		ModuleListComponent,
		TreeChecklistExample
	  ],
  imports: [
    CommonModule,
    // HttpClientModule,
	PartialsModule,
	RouterModule.forChild(routes),
    FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
    MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatTreeModule,
	NgbModule
  ],
  providers: [
		// InterceptService,
		// {
        // 	provide: HTTP_INTERCEPTORS,
       	//  	useClass: InterceptService,
		// 	multi: true
		// },
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		MachineService,
		ProductService,
		ShiftService,
		QuartelService
  ],
  entryComponents: [
		ActionNotificationComponent,
  ],
})
export class Controlir4ConfigModule { }
